function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { handleError } from "../store/features/alertSlice";
import { useDispatch } from "react-redux";
import technicalTemplateImportStatusesService from '@rd-web-markets/shared/dist/services/claim/technical_template_import_statuses.service';
import claimGroupService from '../services/claim_group.service';
export const useTechnicalTemplateImportStatus = (claimGroup, setClaimGroup) => {
  const [technicalTemplateImportStatus, setTechnicalTemplateImportStatus] = useState(null);
  const [isTechnicalTemplatePending, setIsTechnicalTemplatePending] = useState(false);
  const dispatch = useDispatch();
  const changePendingStatus = () => {
    setIsTechnicalTemplatePending(prevStatus => !prevStatus);
  };
  useEffect(() => {
    const fetchTechnicalTemplateImportStatus = async () => {
      const technicalTemplateImportStatus = await technicalTemplateImportStatusesService.get(claimGroup.id);
      setTechnicalTemplateImportStatus(technicalTemplateImportStatus);
    };
    fetchTechnicalTemplateImportStatus();
  }, [claimGroup, isTechnicalTemplatePending]);
  useEffect(() => {
    if (isTechnicalTemplatePending) {
      setTechnicalTemplateImportStatus(_objectSpread(_objectSpread({}, technicalTemplateImportStatus), {}, {
        import_status: 'pending'
      }));
      const intervalId = window.setInterval(() => {
        technicalTemplateImportStatusesService.get(claimGroup.id).then(importStatus => {
          if (importStatus.import_status !== 'pending') {
            setIsTechnicalTemplatePending(false);
            claimGroupService.get(claimGroup.id).then(setClaimGroup);
          }
        }).catch(err => {
          dispatch(handleError(err.description));
        });
      }, 5000);
      return () => window.clearInterval(intervalId);
    }
  }, [isTechnicalTemplatePending, claimGroup, dispatch]);
  return [technicalTemplateImportStatus, isTechnicalTemplatePending, changePendingStatus];
};